/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SampleDataFile { 
    /**
     * The directory path of the sample data file. Note that directory path will contain a trailing \"directory\" separator, thus the                   caller needs to concatenate the directory path and the file name as is in order to construct a fully qualified path for the sample data file                
     */
    directoryPath: string;
    /**
     * The name of the sample data file
     */
    fileName: string;
}
